import { Select, Tooltip } from "antd";
import { IFormSelectProps } from "./IFormComponents";
import { InfoCircleOutlined } from "@ant-design/icons";
const { Option } = Select;

const FormSelect = (props: IFormSelectProps) => {
  const {
    options,
    mandatory,
    field,
    onChangeInvestor,
    optionName,
    optionField,
    label,
    value,
    index,
    arrayField,
    multiple,
    disabled,
    error,
    placeholder,
    tooltip,
    shouldSort = true,
  } = props;

  const handleChange = (selectedValue: any) => {
    if (typeof onChangeInvestor === "function") {
      onChangeInvestor(selectedValue, field, index, arrayField);
    }
  };

  return (
    <div className="investor-form-item">
      <label
        className={`${mandatory ? "mandatory" : ""} ${
          error ? "error-input" : ""
        } `}
      >
        {label}
        {tooltip && (
          <Tooltip title={tooltip} placement="right">
            {" "}
            <InfoCircleOutlined style={{ color: "#6b6b6bff" }} />
          </Tooltip>
        )}
      </label>
      <Select
        placeholder={placeholder}
        showSearch
        allowClear={false}
        value={value ?? undefined}
        style={{ width: "100%" }}
        mode={multiple ? "multiple" : undefined}
        maxTagCount="responsive"
        disabled={disabled}
        onChange={handleChange}
        status={error ? "error" : undefined}
        filterOption={(input, option) =>
          (option?.label ?? "")
            .toString()
            .toLowerCase()
            .includes(input.toLowerCase())
        }
      >
        {options?.length &&
          (shouldSort
            ? options
                .slice() 
                .sort((a: any, b: any) =>
                  (a[optionName] ?? "").localeCompare(b[optionName] ?? "")
                )
            : options
          ).map((opt: any) => {
            return (
              <Option
                value={opt[optionField]}
                key={opt[optionName]}
                label={opt[optionName]}
              >
                {opt[optionName]}
              </Option>
            );
          })}
      </Select>
    </div>
  );
};

export default FormSelect;
